export default __webpack_public_path__ + "static/media/periode.972785e0.png";